import {isEmpty, str_replace} from "../../helpers/helpers";
import {inArray, is_array} from "../../helpers/arrays";
import {generateSearchUrl} from "../../organisms/property/helpers/search_helper";
import {getWidgets} from "../../../models/widget";
import {getSearchiDealTypes, getUrlDealTypes} from "../../../models/property";
import {getCityById} from "../../../models/district";
import {getRedisCache, storeRedisCache} from "../../../helpers/redis_cache";

export function handleOtherPagesLinks(defaultCity) {

    const showAreas = [
        259, // tehran
        207, // mashhad
        308, // rasht
        1357, // chamestan
        3165 // pardis
    ];

    const links = [
        {name: 'ثبت رایگان آگهی ملک', hrefAs: "/ثبت/ملک", href: '', crossOverLink: true, id: 'js-in-footer-create-property'},
        {name: 'سوال ملکی دارید؟', hrefAs: "/پرسش-پاسخ", href: '/pages/questions', crossOverLink: false},
        {name: 'اخبار مسکن', hrefAs: "/news", href: '', crossOverLink: true},
        {name: 'وبلاگ ۲نبش', hrefAs: "/blog", href: '/pages/blog', crossOverLink: false},
        {name: 'نقشه سایت', hrefAs: "/نقشه-سایت", href: '/pages/sitemap', crossOverLink: false},
        {name: 'خدمات ۲نبش', hrefAs: "/خدمات-2نبش", href: '/pages/services', crossOverLink: false},
        {name: 'درباره ۲نبش', hrefAs: "/about-us", href: '', crossOverLink: true},
        {name: 'ضوابط و قوانین', hrefAs: "/ضوابط-قوانین", href: '', crossOverLink: true},
        {name: 'تماس با ۲نبش', hrefAs: "/contact", href: '/pages/contact-us', crossOverLink: false},
    ];

    if (!isEmpty(defaultCity) && inArray(defaultCity.id, showAreas)) {
        const name = (defaultCity.id === 259) ? 'مناطق ' + defaultCity.name : 'محله‌های ' + defaultCity.name;
        const newLinks = {name: name, hrefAs: '/محله/' + defaultCity.name, href: '', crossOverLink: true};

        links.push(newLinks);
    }

    return links;
}

export async function handleSpecialLinks(defaultCity) {
    let footerTitle = 'لینک‌های منتخب';
    let links = [];
    const dealType = 'sale';
    const dealTypeName = getSearchiDealTypes(dealType);
    const dealTypeUrl = getUrlDealTypes(dealType);

    // footerTitle = dealTypeName + ' ' + typeName + ' شهرهای منتخب';

    const cities = [
        {id: 259, name: 'تهران', type_name: 'خانه', type_name_url: 'آپارتمان'},
        {id: 207, name: 'مشهد', type_name: 'آپارتمان', type_name_url: 'آپارتمان'},
    ];

    for (let cityItem of cities) {
        links.push({
            name: dealTypeName + ' ' + cityItem.type_name + ' در ' + cityItem.name,
            hrefAs: generateSearchUrl(cityItem.name, cityItem.type_name_url, dealTypeUrl),
            href: '/properties',
            crossOverLink: false
        });

        links.push({
            name: 'املاک ' + cityItem.name,
            hrefAs: '/املاک-' + str_replace(' ', '-', cityItem.name),
            href: '/properties',
            crossOverLink: false
        })
    }

    if (dealType === 'sale' && !isEmpty(defaultCity) && defaultCity.id !== 3198) {
        links.push({name: 'خرید ویلا در شمال', hrefAs: "/املاک-شمال/خرید-فروش-ویلا", href: '/properties', crossOverLink: false},)
    }

    return {
        links: links,
        title: footerTitle
    }
}

async function makeBeforeFooterSectionLinks(city_id, dealType = null, page = null) {
    let links = [];

    if (!isEmpty(page)) {
        const params = {
            type: 'static_links',
            page: page,
            section: 'footer',
            city_id: city_id,
            count: 50
        };

        const widgetLinks = await getWidgets(params);

        if (!isEmpty(widgetLinks) && !isEmpty(widgetLinks.widgets) && widgetLinks.widgets.length) {
            widgetLinks.widgets.map((item, key) => {

                if (isEmpty(item.properties_deal_types) || (is_array(item.properties_deal_types) && !item.properties_deal_types.length) || item.properties_deal_types === dealType) {
                    links.push({
                        name: item.caption,
                        hrefAs: item.url,
                        href: '/properties',
                        crossOverLink: false
                    });
                }
            })
        }
    }

    return links;
}

export async function handleFooterLinks(defaultCityId, dealType = null, page = null) {
    const defaultCity = await getCityById(defaultCityId);

    const otherPagesLinks = await handleOtherPagesLinks(defaultCity);
    const specialLinks = await handleSpecialLinks(defaultCity);
    const beforeFooterSectionLinks = await makeBeforeFooterSectionLinks(defaultCityId, dealType, page);

    return {
        city_id: defaultCityId,
        otherPagesLinks: otherPagesLinks,
        specialLinks: specialLinks,
        beforeFooterSectionLinks: beforeFooterSectionLinks,
    }
}